import { FormsModule } from "@angular/forms";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { SecondsToReadableFormatPipe } from "app/pipes/pipes";
import { IResponseTimeStatistics } from "app/models/statistics.model";
import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
} from "@angular/core";
import { HelperService } from "app/services/helper.service";
import {
  ALARM_CENTER_SIDEBAR_PDF_GROUP,
  StatisticsExportSnapshot,
  StatisticsExportWidget,
} from "app/services/statistics-export.models";
import { renderStatCardToPng } from "app/services/statistics-native-canvas.util";
import { StatisticsPngDownloadBtnComponent } from "../statistics-png-download-btn/statistics-png-download-btn.component";

@Component({
  selector: "response-time-statistics",
  templateUrl: "./response-time-statistics.component.html",
  styleUrls: ["./response-time-statistics.component.css"],
  standalone: true,
  imports: [FormsModule, TranslateModule, SecondsToReadableFormatPipe, StatisticsPngDownloadBtnComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResponseTimeStatisticsComponent implements OnInit, StatisticsExportWidget {
  constructor(
    private translate: TranslateService,
    private helper: HelperService
  ) {}

  @Input() resTimeStats: IResponseTimeStatistics;

  selectedOption: "average" | "median" = "average";

  ngOnInit(): void {}

  // Both the PDF export and the per-widget PNG download draw the grey
  // response-time card with Canvas-2D and embed the resulting PNG (a raster
  // image, but sharp at 2x) — no html2canvas.
  async captureForExport(): Promise<StatisticsExportSnapshot | null> {
    // Export readiness only checks Alarm Center paging + emaacStatistics presence;
    // resTimeStats can still be missing, so skip this widget rather than throwing.
    if (!this.resTimeStats) {
      return null;
    }

    const imageDataUrl = renderStatCardToPng({
      title: this.translate.instant("RESPONSE_TIME"),
      rows: [
        {
          label: this.translate.instant("MEAN_TEXT"),
          value: this.helper.convertSecondsToReadableFormat(this.resTimeStats.avgResTimeSeconds),
        },
        {
          label: this.translate.instant("MEDIAN"),
          value: this.helper.convertSecondsToReadableFormat(this.resTimeStats.medianResTimeSeconds),
        },
      ],
      background: "#e5e8ef",
      foreground: "#07184D",
    });
    if (!imageDataUrl) {
      return null;
    }
    return {
      slug: "response-time-statistics",
      titleKey: "RESPONSE_TIME",
      imageDataUrl,
      pdfPageGroup: ALARM_CENTER_SIDEBAR_PDF_GROUP,
      omitPdfTitle: true,
    };
  }
}
